import { AppVersion, APP_VERSION_URLS } from '@core/constants/appVersion';
import { APP_SWITCH_ORG_PARAM, APP_SWITCH_PARAM } from './appSwitch';

// Builds the URL of the same page on the other app version, tagged with the
// app-switch marker and — for authenticated users — the active organization,
// so both apps resolve the viewer version for the same org (see appSwitch.ts).
const buildAppSwitchUrl = (
  version: AppVersion,
  {
    path = `${window.location.pathname}${window.location.search}`,
    organizationId,
  }: { path?: string; organizationId?: string } = {},
): string => {
  const url = new URL(path, window.location.origin);
  url.searchParams.set(APP_SWITCH_PARAM, '1');
  if (organizationId) {
    url.searchParams.set(APP_SWITCH_ORG_PARAM, organizationId);
  }
  return `${APP_VERSION_URLS[version]}${url.pathname}${url.search}${url.hash}`;
};

export default buildAppSwitchUrl;
